import { Select, Tabs } from 'antd';

import styled from 'styled-components';

import FlexContainer from '@components/Gui/FlexContainer';

export const StyledTabs = styled(Tabs)`
    overflow: unset;
    .ant-tabs-nav {
        .ant-tabs-nav-wrap {
            &::after {
                box-shadow: none !important;
            }
            .ant-tabs-nav-list {
                .ant-tabs-tab {
                    margin: 0 16px 0 0;

                    .ant-tabs-tab-btn {
                        text-transform: uppercase;
                        font-size: 0.75rem;
                    }
                }
            }
        }
    }
`;

export const StyledSelect = styled(Select)`
    width: 100%;
    margin-bottom: 0.5rem;
    .ant-select-selection-item {
        span.is-modified {
            font-size: 0.75rem;
            font-weight: bold;
            background-color: ${(props) => props.theme.DangerColor};
            color: #fff;
            border-radius: 4px;
            padding: 2px 4px;
            margin: 0 1em 0 0;
            vertical-align: middle;
        }
    }
`;

export const StyledSelectDrawer = styled(Select)`
    width: 400px;
    font-weight: bold;
`;

export const FiltersWrapper = styled.div`
    width: ${(props) => props.$breakpoints < 4 && '100%'};
    position: relative;

    .ant-tabs {
        width: 100%;
    }

    .back-to-list,
    .go-to-booking {
        position: absolute;
        top: 0.4rem;
        right: 0.2rem;
        cursor: pointer;
    }

    .filters-tab-content {
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        align-items: flex-start;
        margin-top: 1rem;

        /* tab vuoto (es. "all" nella sidebar): i quick filter mini sotto hanno già il loro margine,
           così il primo controllo sta alla stessa distanza dai tab dei select negli altri tab */
        &:empty {
            margin-top: 0.5rem;
        }

        .filters-tab-content-wrapper {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            @media (max-width: 1280px) {
                margin: 0 0 8px;
            }

            &.active-set-changed {
                .ant-select-selector {
                    border-color: ${(props) => props.theme.DangerColor};
                }
                span.unsaved-changes {
                    text-align: center;
                    font-size: ${(props) => props.theme.FontSizeSm};
                    color: ${(props) => props.theme.DangerColor};
                    padding: 0 0 4px 0;
                    text-transform: uppercase;
                    width: 100%;
                    vertical-align: middle;
                }
            }
        }
        .folders-buttons {
            width: 100%;
            margin: 4rem 0 0;
            display: flex;
            flex-direction: column;
            gap: 1rem;
            justify-content: flex-start;
            align-items: center;
        }
    }

    //condivisa con ContactsFiltersSmartListsForm: stessa riga di bottoni per "actions on current X".
    //flex-basis 0 con grow 1 fa dividere lo spazio a meta' tra i due bottoni (il divider tra loro
    //mantiene la sua larghezza naturale) e si adatta da solo se un domani i bottoni diventano 3
    .filter-actions {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
        padding: 0.25rem 0;

        //NwRemoveButton avvolge il bottone nel Popover di conferma: il flex item e' quel wrapper,
        //quindi senza queste due regole cresce solo l'altro bottone
        > button,
        > .ant-dropdown-link {
            flex: 1 1 0;
        }

        > .ant-dropdown-link button {
            width: 100%;
        }

        button {
            font-size: 0.8em;
            font-weight: bold;
        }
    }
`;
